import { HStack, Switch, SwitchProps, Text } from '@chakra-ui/react'
import { Controller, FieldValues, Path } from 'react-hook-form'

import { Inputs } from './models'

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K>,
    SwitchProps {
  label: string
}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { control },
    useFormField,
    label,
    ...rest
  } = props

  return (
    <Controller
      control={control}
      name={useFormField}
      render={({ field: { onChange, value } }) => (
        <HStack>
          <Switch onChange={onChange} isChecked={value || false} {...rest} />
          <Text>{label}</Text>
        </HStack>
      )}
    />
  )
}
